module.exports = __webpack_public_path__ + "static/media/gallery5.05128f57.jpg";